import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Helmet } from 'react-helmet';
export function GoogleAnalytics() {
    var hostname = window.location.hostname;
    var isProduction = hostname === 'bootstrapworks.com';
    var measurementId = isProduction ? 'G-41QC9WHVBM' : 'G-DL2PRJZ9XK';
    console.log(isProduction ? 'production' : 'development/staging', hostname, measurementId);
    return (_jsx(_Fragment, { children: _jsxs(Helmet, { children: [_jsx("script", { async: true, src: "https://www.googletagmanager.com/gtag/js?id=" + measurementId }, void 0),
                _jsx("script", { children: "window.dataLayer = window.dataLayer || [];\n            function gtag(){dataLayer.push(arguments);}\n            gtag('js', new Date());\n            gtag('config', '" + measurementId + "');" }, void 0)] }, void 0) }, void 0));
}
//# sourceMappingURL=google-analytics.js.map